export default __webpack_public_path__ + "static/media/7_6.c375eee6.png";